
import React from 'react';
// import { makeStyles } from '@material-ui/styles';


// const useStyles = makeStyles(theme => ({
//   content: {
//     marginTop: theme.spacing(2)
//   }
// }));

const PdfResume = () => {
  // const classes = useStyles();
  return (
    <div></div>
    // <div className={classes.content} style={{ background: '#FFF', textAlign: 'center', marginLeft: '2%', marginRight: '2%', boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)' }}>
    //   <object width="100%" height="800px" data="/docs/curriculum.pdf" type="application/pdf">   </object>
    // </div>
  );
};


export default PdfResume;
